var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVegLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5026 2.66634C13.239 2.66634 13.8359 3.26329 13.8359 3.99967V11.9997C13.8359 12.7361 13.239 13.333 12.5026 13.333H4.50261C3.76623 13.333 3.16927 12.7361 3.16927 11.9997V3.99968C3.16927 3.2633 3.76622 2.66634 4.5026 2.66634H12.5026ZM15.1693 2.66634C15.1693 1.92996 14.5723 1.33301 13.8359 1.33301H3.16927C2.43289 1.33301 1.83594 1.92996 1.83594 2.66634V13.333C1.83594 14.0694 2.43289 14.6663 3.16927 14.6663H13.8359C14.5723 14.6663 15.1693 14.0694 15.1693 13.333V2.66634ZM8.5026 3.99967C6.29594 3.99967 4.5026 5.79301 4.5026 7.99967C4.5026 10.2063 6.29594 11.9997 8.5026 11.9997C10.7093 11.9997 12.5026 10.2063 12.5026 7.99967C12.5026 5.79301 10.7093 3.99967 8.5026 3.99967Z",
    fill: "#028338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegLogo);
export default __webpack_public_path__ + "static/media/veg-logo.e358ae0f3b2e55789bcc38019a5e9443.svg";
export { ForwardRef as ReactComponent };